/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Client module `BreakfastEventForm` for the Caintra Connect frontend.
 * @module pages/BreakfastEventForm
 *
 * Conventions:
 * - Keep components focused on rendering; move branching logic into hooks or utils.
 * - Prefer named exports for helpers and default exports for React components.
 * - Reuse shared validation, i18n, and API helpers from client/src/utils and logic/.
 */
import BreakfastEventFormView from "./BreakfastEventFormView.jsx";
import useBreakfastEventForm from "../hooks/useBreakfastEventForm.js";

const BreakfastEventForm = () => {
  const { allowed, viewProps } = useBreakfastEventForm();
  if (!allowed) {
    return null;
  }
  return <BreakfastEventFormView {...viewProps} />;
};

export default BreakfastEventForm;
